export default {"src":"/_next/static/media/logo-small.e3145839.svg","height":74,"width":90,"blurWidth":0,"blurHeight":0};